import { cn } from 'src/lib/utils';

interface ErrorInfoProps {
  title: string;
  description: string;
  onClose?: () => void;
  closeLabel?: string;
}

export const ErrorInfo = ({
  title,
  description,
  children,
  onClose,
  closeLabel = 'Close',
}: React.PropsWithChildren<ErrorInfoProps>) => {
  return (
    <>
      {children}

      <div className="flex flex-col items-center gap-4 text-center">
        <h1 className="
          text-accent-brand-highlight text-silver-darken-90
          dark:text-white
        ">
          {title}
        </h1>

        <p className="
          max-w-xs text-body-brand-regular text-silver-darken-80
          dark:text-silver-darken-20
        ">
          {description}
        </p>

        {onClose && (
          <button
            className={cn(
              'w-full bg-orange-lighten-30 text-silver-darken-90 shadow-level-1',
              'dark:border-orange dark:bg-black/1 dark:text-orange-lighten-75',
              'hover:brightness-120',
            )}
            id="pd_btn_go_to_home_page"
            onClick={onClose}
          >
            {closeLabel}
          </button>
        )}
      </div>
    </>
  );
};
